@if ({ currentPageData: currentPageData | async }; as content) {
  @if (content.currentPageData?.pagination) {
    <span>
      {{
      getDisplayValue(content.currentPageData?.pagination?.totalResults ?? 0, content.currentPageData?.pagination?.pageSize ?? 0).display
      }}
      of
      {{ getDisplayValue(content.currentPageData?.pagination?.totalResults ?? 0, content.currentPageData?.pagination?.pageSize ?? 0).total }}
    </span>
  }
}
